import React from "react";

const BarInCell = ({
  value,
  max,
  color = "#5B7CFF",
  bg = "rgba(255,255,255,0.04)",
  height = 6,
  label,
  textColor = "#F5F5F5"
}) => {
  const pct = max > 0 ? Math.min(100, (value / max) * 100) : 0;
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 4, minWidth: 80 }}>
      <span
        style={{
          fontSize: 12,
          fontWeight: 700,
          fontVariantNumeric: "tabular-nums",
          color: textColor,
          lineHeight: 1.2
        }}
      >
        {label != null ? label : value}
      </span>
      <div
        style={{
          width: "100%",
          height,
          background: bg,
          borderRadius: height / 2,
          overflow: "hidden"
        }}
      >
        <div
          style={{
            width: pct + "%",
            height: "100%",
            background: color,
            borderRadius: height / 2,
            transition: "width 240ms ease"
          }}
        />
      </div>
    </div>
  );
};

export default BarInCell;
